import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

import { Neutrals, SemanticError, SemanticSuccess } from '../../../../core-components/theme/color-palette/colors';
import { PROSE_MAX } from '../../../../core-components/theme/components/Screen';
import { ADMIN_CONTROLS_MAX } from '../../constants/adminLayout';

export const headerLineSx: SystemStyleObject<Theme> = { display: 'block', overflowWrap: 'anywhere' };

export const SECTION_SUMMARY_MAX = '24ch';

export const sectionSummarySx: SystemStyleObject<Theme> = {
  display: 'block',
  maxInlineSize: SECTION_SUMMARY_MAX,
  color: Neutrals[600],
  fontVariantNumeric: 'tabular-nums',
  overflowWrap: 'anywhere',
  textAlign: 'end',
};

export const sectionBodySx: SystemStyleObject<Theme> = { display: 'flex', flexDirection: 'column', gap: 4, minInlineSize: 0 };

export const blockControlsSx: SystemStyleObject<Theme> = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'flex-start',
  columnGap: 6,
  rowGap: 3,
  minInlineSize: 0,
};

export const switchFieldSx: SystemStyleObject<Theme> = {
  inlineSize: 'auto',
  flexShrink: 0,
  '@media (pointer: coarse)': {
    '& .MuiFormControlLabel-root': { minBlockSize: (theme: Theme) => theme.controlHeight.medium },
  },
};

export const helpTextSx: SystemStyleObject<Theme> = { color: Neutrals[700], maxInlineSize: PROSE_MAX };

const semiBold = (theme: Theme): number => theme.typography.fontWeightSemiBold;

export const helpWarningSx: SystemStyleObject<Theme> = { color: SemanticError[600], fontWeight: semiBold };

export const saveBlockSx: SystemStyleObject<Theme> = { display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'flex-start' };

export const saveRowSx: SystemStyleObject<Theme> = { display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 3 };

export const savedNoteSx: SystemStyleObject<Theme> = { color: SemanticSuccess[900], fontWeight: semiBold };

export const fieldStackSx: SystemStyleObject<Theme> = { display: 'flex', flexDirection: 'column', gap: 3, maxInlineSize: ADMIN_CONTROLS_MAX };

export const readOnlyFactSx: SystemStyleObject<Theme> = { color: Neutrals[700], fontVariantNumeric: 'tabular-nums' };

export const cellStackSx: SystemStyleObject<Theme> = { display: 'flex', flexDirection: 'column', gap: 1, minInlineSize: 0 };

export const groupListSx: SystemStyleObject<Theme> = { listStyle: 'none', margin: 0, padding: 0, display: 'inline' };

export const groupItemSx: SystemStyleObject<Theme> = { display: 'inline' };

export const roleWordSx: SystemStyleObject<Theme> = { color: Neutrals[600] };

export const inlineTextSx: SystemStyleObject<Theme> = { margin: 0, overflowWrap: 'anywhere' };

export const mutedLineSx: SystemStyleObject<Theme> = { margin: 0, color: Neutrals[700], overflowWrap: 'anywhere' };

export const loudnessSx: SystemStyleObject<Theme> = { margin: 0, color: Neutrals[600], fontVariantNumeric: 'tabular-nums' };

export const alarmLineSx: SystemStyleObject<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  margin: 0,
  color: SemanticError[600],
  fontWeight: semiBold,
};

export const calmLineSx: SystemStyleObject<Theme> = { margin: 0, color: Neutrals[600] };

export const failuresSx: SystemStyleObject<Theme> = { display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'flex-start' };

export const countSx: SystemStyleObject<Theme> = { fontVariantNumeric: 'tabular-nums' };
